import { render } from "./PARTY_UPDATED_WEBSITE.vue?vue&type=template&id=2be23748"
import script from "./PARTY_UPDATED_WEBSITE.vue?vue&type=script&lang=js"
export * from "./PARTY_UPDATED_WEBSITE.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__